export enum ReportType {
    FULL = 'Multi Data Points',
    SIMPLE = 'Start & End Data Points',
    SINGLE_STEP = 'Single Data Point'
}

export interface CollectionItem {
    featureName: string,
    featureType: string,
    featureUUID?: string,
    disabled?: boolean
}

export interface ActiveAction {
    id: string;
    action: string;
    item: CollectionItem;
  }
